import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Modal, notification } from "antd";
import { Button, Loading } from "~/components";
import { InputField, TextAreaField } from "~/components/Forms";
import { handleRequest, apiError } from "~/utils";
import { customerApi } from "~/api";

/**
 * Modal thêm khách hàng nhanh trong POS
 * Chỉ yêu cầu thông tin cơ bản: Tên, SĐT, Địa chỉ
 */
function AddCustomerModal({ open, onClose, onSuccess }) {
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Tên khách hàng không được bỏ trống'),
        phone: Yup.string().required('Số điện thoại không được bỏ trống'),
    });

    const { control, handleSubmit, formState: { isSubmitting, errors }, reset } = useForm({
        defaultValues: {
            code: '',
            name: '',
            phone: '',
            address: '',
            note: '',
        },
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = async (data) => {
        try {
            // Auto generate code from phone number
            let [error, response] = await handleRequest(customerApi.add(data));

            if (!apiError('Thêm khách hàng thất bại', error, response)) {
                notification.success({
                    message: 'Thành công',
                    description: 'Thêm khách hàng thành công'
                });

                reset();
                onSuccess?.(response.data);
                onClose?.();
            }
        } catch (err) {
            notification.error({
                message: 'Lỗi',
                description: err.message || 'Có lỗi xảy ra'
            });
        }
    };

    const handleCancel = () => {
        reset();
        onClose?.();
    };

    return (
        <Modal
            title="Thêm khách hàng mới"
            open={open}
            onCancel={handleCancel}
            footer={null}
            width={600}
            centered
        >
            <form className={'form'} onSubmit={handleSubmit(onSubmit)}>
                {isSubmitting && <Loading />}

                <Controller
                    control={control}
                    name="name"
                    render={({ field }) => (
                        <InputField
                            label="Tên khách hàng"
                            placeholder="Nhập tên khách hàng"
                            errors={errors}
                            {...field}
                        />
                    )}
                />

                <Controller
                    control={control}
                    name="phone"
                    render={({ field }) => (
                        <InputField
                            type="tel"
                            label="Số điện thoại"
                            placeholder="Nhập số điện thoại"
                            errors={errors}
                            {...field}
                        />
                    )}
                />

                <Controller
                    control={control}
                    name="address"
                    render={({ field }) => (
                        <InputField
                            type="text"
                            label="Địa chỉ"
                            placeholder="Nhập địa chỉ"
                            errors={errors}
                            {...field}
                        />
                    )}
                />

                <Controller
                    control={control}
                    name="note"
                    render={({ field }) => (
                        <TextAreaField
                            label="Ghi chú (tùy chọn)"
                            placeholder="Nhập ghi chú"
                            errors={errors}
                            {...field}
                        />
                    )}
                />

                <div className="form-group d-flex justify-content-end" style={{ gap: '10px', marginTop: '20px' }}>
                    <Button onClick={handleCancel} disabled={isSubmitting}>
                        Hủy
                    </Button>
                    <Button primary type="submit" disabled={isSubmitting}>
                        Thêm khách hàng
                    </Button>
                </div>
            </form>
        </Modal>
    );
}

export default AddCustomerModal;
